import { NgModule } from '@angular/core';
import { SmtModalComponent } from '../modals/smt-modal.component'
import { SmtSessionModelComponent } from '../modals/smt-session-model/smt-session-model.component';
import { ExpandableListComponent} from '../Baseclasses/expandable-list.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ExpandableListOrderedComponent } from '../Baseclasses/expandable-list-ordered.component';
import { ExpandableListComboComponent } from '../Baseclasses/expandable-list-combo.component';
import { HuronMappingPageComponent } from '../admin-page/mapping-page.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DxSelectBoxModule } from "devextreme-angular";

@NgModule({
	imports: [CommonModule,FormsModule,DragDropModule,InfiniteScrollModule,DxSelectBoxModule],
	declarations: [SmtModalComponent,SmtSessionModelComponent,ExpandableListComponent,ExpandableListOrderedComponent,ExpandableListComboComponent,HuronMappingPageComponent],
	exports: [SmtModalComponent,SmtSessionModelComponent,ExpandableListComponent,ExpandableListOrderedComponent,ExpandableListComboComponent,HuronMappingPageComponent]
}) 
export class SmtSharedModule {
}
